import { usePathname } from 'next/navigation';
import { Button } from '@/components/button';
import type { NavItem } from '@/utils/navigation.utils';
import {
  generatePathWithExistingPrefix,
  isNavItemOrGroupActive,
  NavItemType,
} from '@/utils/navigation.utils';

export type NavigationItemProps = {
  item: NavItem;
};

export const NavigationItem = ({ item }: NavigationItemProps) => {
  const pathname = usePathname();
  const isActive = isNavItemOrGroupActive({
    currentPath: pathname,
    item,
  });

  const generatedHref = generatePathWithExistingPrefix({
    currentPath: pathname,
    targetPath: item.path,
    matchGamePrefix: item.navItemType === NavItemType.GamePage,
  });

  return (
    <Button
      as="link"
      className="mx-2"
      href={generatedHref}
      variant={isActive ? 'primary' : 'ghost'}
    >
      {item.icon && <span className="shrink-0">{item.icon}</span>}
      {item.name}
    </Button>
  );
};
